module.exports = __webpack_public_path__ + "static/media/WI.62954428.png";